// extracted by mini-css-extract-plugin
module.exports = {"map-a5":"Map_map-a5__1mX9o","map-a4":"Map_map-a4__1Frb9","bubbleRebowl":"Map_bubbleRebowl__1pa8a","bubbleRecup":"Map_bubbleRecup__2e-QP"};